var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { attrs: { id: "componentsToolbar" } }, [
        _c(
          "div",
          { staticClass: "btn-spaced-group", attrs: { role: "form" } },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.projectAddComponentModal",
                    modifiers: { projectAddComponentModal: true },
                  },
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                    expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                  },
                ],
                attrs: { size: "md", variant: "outline-primary" },
              },
              [
                _c("span", { staticClass: "fa fa-plus" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("message.add_component")) + "\n      "
                ),
              ]
            ),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                    expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                  },
                ],
                attrs: { size: "md", variant: "outline-primary" },
                on: { click: _vm.removeDependencies },
              },
              [
                _c("span", { staticClass: "fa fa-minus" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("message.remove_component")) + "\n      "
                ),
              ]
            ),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.projectUploadBomModal",
                    modifiers: { projectUploadBomModal: true },
                  },
                  {
                    name: "permission",
                    rawName: "v-permission:or",
                    value: [
                      _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                      _vm.PERMISSIONS.BOM_UPLOAD,
                    ],
                    expression:
                      "[\n          PERMISSIONS.PORTFOLIO_MANAGEMENT,\n          PERMISSIONS.BOM_UPLOAD,\n        ]",
                    arg: "or",
                  },
                ],
                attrs: {
                  id: "upload-button",
                  size: "md",
                  variant: "outline-primary",
                },
              },
              [
                _c("span", { staticClass: "fa fa-upload" }),
                _vm._v(" " + _vm._s(_vm.$t("message.upload_bom")) + "\n      "),
              ]
            ),
            _c(
              "b-tooltip",
              { attrs: { target: "upload-button", triggers: "hover focus" } },
              [_vm._v(_vm._s(_vm.$t("message.upload_bom_tooltip")))]
            ),
            _c(
              "b-dropdown",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
                    expression: "PERMISSIONS.VIEW_PORTFOLIO",
                  },
                ],
                attrs: { variant: "outline-primary" },
                scopedSlots: _vm._u([
                  {
                    key: "button-content",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "fa fa-download" }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.download_bom")) +
                            "\n        "
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c(
                  "b-dropdown-item",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadBom("inventory")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("message.inventory")))]
                ),
                _c(
                  "b-dropdown-item",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadBom("withVulnerabilities")
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("message.inventory_with_vulnerabilities"))
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "b-dropdown",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
                    expression: "PERMISSIONS.VIEW_PORTFOLIO",
                  },
                ],
                attrs: { variant: "outline-primary" },
                scopedSlots: _vm._u([
                  {
                    key: "button-content",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "fa fa-download" }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.download_component")) +
                            "\n        "
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c(
                  "b-dropdown-item",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadTable("csv")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("message.csv_filetype")))]
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "keep-together",
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: { id: "switch-container-outdated" },
              },
              [
                _c(
                  "c-switch",
                  _vm._b(
                    {
                      attrs: {
                        id: "only-outdated",
                        disabled: !_vm.project,
                        color: "primary",
                        label: "",
                      },
                      model: {
                        value: _vm.onlyOutdated,
                        callback: function ($$v) {
                          _vm.onlyOutdated = $$v
                        },
                        expression: "onlyOutdated",
                      },
                    },
                    "c-switch",
                    _vm.labelIcon,
                    false
                  )
                ),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("message.outdated_only"))),
                ]),
              ],
              1
            ),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "switch-container-outdated",
                  triggers: "hover focus",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.only_outdated_tooltip")))]
            ),
            _c(
              "span",
              {
                staticClass: "keep-together",
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: { id: "switch-container-direct" },
              },
              [
                _c(
                  "c-switch",
                  _vm._b(
                    {
                      attrs: {
                        id: "only-direct",
                        disabled:
                          !_vm.project || !this.project.directDependencies,
                        color: "primary",
                        label: "",
                      },
                      model: {
                        value: _vm.onlyDirect,
                        callback: function ($$v) {
                          _vm.onlyDirect = $$v
                        },
                        expression: "onlyDirect",
                      },
                    },
                    "c-switch",
                    _vm.labelIcon,
                    false
                  )
                ),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("message.direct_only"))),
                ]),
              ],
              1
            ),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "switch-container-direct",
                  triggers: "hover focus",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.only_direct_tooltip")))]
            ),
          ],
          1
        ),
      ]),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: { "on-load-success": _vm.tableLoaded },
      }),
      _c("project-upload-bom-modal", { attrs: { uuid: this.uuid } }),
      _c("project-add-component-modal", {
        attrs: { uuid: this.uuid },
        on: { refreshTable: _vm.refreshTable },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }